export default function PrivacyPolicy() {
    return (
        <section className="term-service privacy-Policy">
            <div className="term-and-service-h1">
                        <h1>Privacy Policy</h1>
                    </div>
            <div className="container-wrap">
                <div className="term-service-wrpp">
                    
                    <div className="term-and-service-p">
                        <p>Welcome to HubSyntax. We are committed to protecting your privacy and ensuring that your personal information is safe. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our services.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Information We Collect</p>
                    </div>
                    <div className="term-and-service-p"  style={{marginBottom:'13px'}}>
                        <p>We may collect personal information that you provide to us directly, such as when you register for our services, fill out a form, or contact us. This information may include:</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Name</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Email address</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Phone number</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Billing information</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Any other information you choose to provide</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>How We Use Your Information</p>
                    </div>
                    <div className="term-and-service-p" style={{ marginBottom: '13px' }}>
                        <p>We use the information we collect in the following ways:</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>1. To provide, operate, and maintain our services </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>2. To improve, customize, and expand our services </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>3. To understand and analyze how you use our services</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>4. To develop services, features, and functionality</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>5. To communicate with you, for providing updates and other information relating to the service, and for marketing and promotional purposes </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>6. To process your transactions and manage your orders </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>7. To find and prevent fraud </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>How We Share Your Information </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We do not sell or transfer your personal information to outside parties unless we provide you with advance notice.</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property, or safety. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Data Security </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We implement a variety of security measures to maintain the safety of your personal information. These measures include encryption, firewalls, and secure socket layers (SSL) technology.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Your Rights</p>
                    </div>
                    <div className="term-and-service-p" style={{ marginBottom: '13px' }}>
                        <p>You have the right to:</p>
                    </div>
                    <div class="term-and-service-li"><ul>
                        <li >Access the personal information we hold about you</li>
                        <li>Request the correction of inaccurate or incomplete personal information</li>
                        <li>Request the deletion of your personal information</li>
                        <li>Request the restriction of processing your personal information</li>
                        <li>Request the transfer of your personal information to another party</li>
                    </ul>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Cookies and Tracking Technologies</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>HubSyntax uses cookies to give you the best online experience. If you continue to use this site, you agree to the use of cookies. You can turn cookies off by changing your browser settings.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Age limits</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Our services are not planned for users under the age of 16. We don’t knowingly allow such persons to use the website. If we find that we have collected personal data about a child under age 16, we will delete that personal data as quickly as possible</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Third-Party Services</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We may use third-party services to facilitate our service, to provide the service on our behalf, or to perform service-related services. These third parties have access to your personal information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Changes to This Privacy Policy</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We may update our Privacy Policy from time to time. We will notify you of any changes made to this page. You are advised to review this Privacy Policy periodically for any changes.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Contact Us</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@hubsyntax.com</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
